"use client"
import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      light: "rgba(26, 187, 156, 0.5)",
      main: "#1ABB9C",
      dark: "#003329",
      contrastText: "#fff",
    },
    secondary: {
      light: "#E9E9E9",
      main: "#30133D",
      dark: "#CA2525",
      contrastText: "#000",
    },
  },
  typography: {
    fontFamily: "roboto",
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.severity === "info" && {
            backgroundColor: "#60a5fa",
          }),
        }),
      },
    },
  },
})

export default theme
